import { Request } from 'components/Request.jsx';
import requestErrorMessage from 'functions/requestErrorMessage';

// Asks the opponent for a rematch. On success the finished match closes so the
// new one takes over; a refusal or failed request rejects with the reason.
export default function requestRematch(match) {
	return Request.post(`${siteUrl}/matchmaking/rematch`, { match_id: match.id })
		.then((response) => {
			if(!response || !response.success) {
				return Promise.reject(requestErrorMessage(response));
			}
			match.closeMatch();
			return response;
		}, (failure) => Promise.reject(requestErrorMessage(failure)));
}
